import React, { useContext } from "react";
import { DashboardContext } from "../../Context/DashboardContext";
import ShortListedMessage from "../OnlineInterview/ShortListedMessage";
import { Card, Flex } from "antd";
import RejectedMessage from "../OnlineInterview/RejectedMessage";
import HiredMessage from "../OnlineInterview/HiredMessage";

const Result = () => {
  const { appliedJob, jobDescription } = useContext(DashboardContext);

  if (!appliedJob || !jobDescription) {
    return null;
  }

  const isShortlisted = appliedJob.status === "shortlisted";
  const isHired = appliedJob.status === "hired";
  const isRejected = appliedJob.status === "rejected";

  return (
    <>
      <Card
        className="requirements_container"
        bordered={false}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Flex
          justify="center"
          align="center"
          style={{ height: "100%", width: "100%" }}
        >
          {isShortlisted && <ShortListedMessage />}
          {isHired && <HiredMessage />}
          {isRejected && <RejectedMessage />}
        </Flex>
      </Card>
    </>
  );
};

export default Result;
